import { apiClient } from '@/api/client';

export const getGenerationMusicDownloadUrl = async (musicId: string): Promise<string> => {
  try {
    const response = await apiClient.get<{ url: string }>(
      `/v1/suggestions/music/${musicId}/download`
    );

    if (!response.data?.url) {
      throw new Error('다운로드 URL을 찾을 수 없습니다.');
    }

    return response.data.url;
  } catch (error) {
    throw new Error('음원 다운로드 중 오류가 발생했습니다.');
  }
};
